import React, { Component } from "react";
import { Container, Grid } from "@mui/material";
import axios from "axios";
import { baseUrl } from "../assets/baseUrl";
import { sourceBaseForImage } from "../assets/source";
import { FaTiktok } from 'react-icons/fa';

class Footer extends Component {
  state = {
    teacherInfo: {},
  };

  componentDidMount() {
    axios.get(`${baseUrl}api/Setting`).then((res) => {
      this.setState({
        teacherInfo: res.data,
      });
      // console.log(teacherInfo);
    });
  }

  render() {
    const { teacherInfo } = this.state;
    return (
      <div className="site-footer" id="footer-section">
        <footer>
          <Container>
            <Grid container fixed spacing={4} className="footer-section-box">
              <Grid item xs={12} sm={6} md={4} lg={5} className="logo-box">
                <div className="footer-logo-content">
                  <div className="logo">
                    <img
                      src={`${sourceBaseForImage}/logo.png`}
                      alt=""
                    />
                  </div>
                  <div className="social">
                    <a href={teacherInfo.whatsappLink} target="_blank">
                      <i className="fab fa-whatsapp"></i>
                    </a>
                    <a href={teacherInfo.telegramLink} target="_blank">
                      <i className="fab fa-telegram"></i>
                    </a>
                    <a href={teacherInfo.facebookLink} target="_blank">
                      <i className="fab fa-facebook-f"></i>
                    </a>
                    <a href={teacherInfo.youtubeChannel} target="_blank">
                      <i className="fab fa-youtube"></i>
                    </a>

                    <a href={teacherInfo.instagramLink} target="_blank">
                      <i className="fab fa-instagram"></i>
                    </a>
                    <a href={teacherInfo.tiktokLink} target="_blank">
                      {/* <i className="fab fa-music-note"></i> */}
                      <FaTiktok size={25} ></FaTiktok>
                    </a>
                    
                  </div>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={4}>
                <div className="more-important">
                  <h5>هام جدا</h5>
                  <ul className="list-unstyled">
                    <li>
                      <span>انستاباى :</span>
                      <span> {teacherInfo.phoneNumber} </span>
                    </li>

                    <li>
                      <span>فودافون كاش : </span>
                      <span> {teacherInfo.vodafonCachPhoneNumber} </span>
                    </li>

                    <li>
                      <span>رقم الهاتف: </span>
                      <span> {teacherInfo.phoneNumber} </span>
                    </li>
                    <li>
                      <span>رقم السكرتاريه: </span>
                      <span> {teacherInfo.secretarialPhoneNumber} </span>
                    </li>
                  </ul>
                </div>
              </Grid>
            </Grid>
          </Container>
        </footer>
        <div className="copy powered-by">
          <Container>
            <h5>
              <span>جميع الحقوق محفوظه</span>
              <span style={{ fontWeight: "400" }}>
                Developed By
                <strong className="powered-by-link">
                  {" "}
                  <a
                    href="https://facebook.com/BrainySoftware23"
                    target="_blank"
                  >
                    {" "}
                    Brainy Software{" "}
                  </a>
                </strong>
              </span>
            </h5>
          </Container>
        </div>
      </div>
    );
  }
}

export default Footer;
